import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";

export default function Services() {
  const { content } = useContent();
  const services = content?.services || [];

  return (
    <div data-testid="services-page">
      <PageHeader
        eyebrow="Services"
        title="Everything your brand needs to show up."
        intro="From the first business card to a full-scale live production — we design, print and produce it all under one roof."
      />
      <section className="bg-[#FAFAFA] py-20 md:py-28 px-6 md:px-12 lg:px-16">
        <div className="max-w-[1400px] mx-auto space-y-0 border-t border-black/15">
          {services.map((sv, i) => (
            <Reveal key={sv.id} delay={i * 0.04}>
              <div data-testid={`service-row-${i}`} className="group grid grid-cols-1 md:grid-cols-12 gap-6 py-12 border-b border-black/15 items-start hover:pl-4 transition-all duration-500">
                <span className="md:col-span-1 font-mono-t text-sm text-zinc-400">0{i + 1}</span>
                <div className="md:col-span-4">
                  <h2 className="font-display text-4xl md:text-5xl tracking-tight">{sv.title}</h2>
                  <p className="font-mono-t text-xs uppercase tracking-widest text-zinc-500 mt-3">{sv.subtitle}</p>
                </div>
                <p className="md:col-span-5 text-zinc-600 text-lg leading-relaxed">{sv.description}</p>
                <div className="md:col-span-2 flex flex-wrap gap-2 md:justify-end">
                  {(sv.tags || []).map((t) => (
                    <span key={t} className="text-xs border border-black/20 px-3 py-1 font-mono-t uppercase tracking-wide">{t}</span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="max-w-[1400px] mx-auto mt-16">
          <Link to="/contact" data-testid="services-cta" className="btn-fill inline-flex items-center gap-2 border border-black px-8 py-4 font-semibold">
            Discuss your project <ArrowUpRight size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
}
